export const favoriteBooks = [
  {
    id: 1,
    cover: '/images/Introduction/book-alchemisty.webp',
    title: 'The Alchemist',
    author: 'Paulo Coelho',
    category: 'Fiction',
    whyILikeIt: `As someone who's always trying to plan everything out and make all the "right" moves, this book
                 hit me in a way I didn't expect. It made me realize that life is wild, unpredictable, and totally uninterested in my little
                 spreadsheets and plans. Sometimes, it's actually worth letting your heart, your gut, or even a 
                 random tumbleweed take the wheel and see where it goes.`
  },
  {
    id: 2,
    cover: '/images/Introduction/book-atomichabits.webp',
    title: 'Atomic Habits',
    author: 'James Clear',
    category: 'Non-Fiction',
    whyILikeIt: `Honestly, I picked up Atomic Habits hoping it would magically fix all my bad habits overnight. 
                 Spoiler: it didn't. But weirdly, I think it did something even better. It helped me actually understand my habits, 
                 the good and the not-so-great ones. And somewhere along the way, I realized the real fix wasn't hiding in the pages 
                 of a book, it was more about looking inward. I'm still working on it, but at least now I've got a better map.`
  },
  {
    id: 3,
    cover: '/images/Introduction/book-underc.webp',
    title: 'The Undercover Economist',
    author: 'Tim Harford',
    category: 'Non-Fiction',
    whyILikeIt: `This book pulled back the curtain on simple economics like why movie snacks cost more than the ticket 
                 and how companies trick me into spending. Harford makes it all click, and it felt like I'd been seeing 
                 the world with one eye shut and this book opened the other. But plot twist, just because I know the game 
                 now doesn't mean I'm winning. I'm still broke, just more aware of why.`
  },
  {
    id: 4,
    cover: '/images/Introduction/book-felices.webp',
    title: 'Felices Días Tío Sergio',
    author: 'Magali García Ramis',
    category: 'Fiction',
    whyILikeIt: `I was basically forced to read this book for a Spanish literature exam, and I honestly 
                 hated every second of it while it was happening. But weirdly enough, all those painful paragraphs that had me 
                 clinging to Google Translate actually leveled up my Spanish big time. So now I've got this weird appreciation 
                 for it. I kind of love that I hated it, if that makes any sense.`
  },
  {
    id: 5,
    cover: '/images/Introduction/book-msreadme.webp',
    title: 'The Missing README',
    author: 'Chris Riccomini & Dmitriy Ryaboy',
    category: 'Non-Fiction',
    whyILikeIt: `This book honestly saved me from looking totally clueless when I was just starting out 
                  in my career. In school, you kind of learn what software "is", like getting a degree in "software theory" or 
                  "software learning", but this book helped me understand what software "engineering" actually looks like in the 
                  real world. It bridged that awkward gap between classroom knowledge and actual "software building", and made 
                  the whole thing feel way more doable.`
  }
]; 